import moment from "moment";

export const DATA_PONTO_DE_PARTIDA = moment({ year: 2018 })
  .endOf("year")
  .startOf("month");
